<template>
  <div class="side-nav-login">
    <div id="loginform">
      <div class="context" v-if="isOtpFieldOpen">
        {{ $t("LoginPage.enterCode") }}
      </div>
      <label v-if="!isOtpFieldOpen">{{
        $t("LoginPage.enterPhoneNumberOrMail")
      }}</label>
      <label v-else>{{ userInput }}</label>
      <v-form class="mt-2" v-model="form" @submit.prevent>
        <div>
          <v-text-field
            v-if="!isOtpFieldOpen"
            :disabled="isOtpFieldOpen"
            type="text"
            id="userEmail"
            :placeholder="$t('LoginPage.userInputPlaceHolder')"
            v-model="userInput"
            :rules="[required]"
            @keyup.enter="submitedData"
            tabindex="1"
          />
          <v-slide-y-reverse-transition hide-on-leave>
            <div v-if="isOtpFieldOpen" class="otp-input-container">
              <input
                ref="otpAutofillProxy"
                type="text"
                inputmode="numeric"
                autocomplete="one-time-code"
                maxlength="4"
                class="otp-autofill-proxy"
                @input="onOtpAutofillProxyInput"
                @keyup.enter="submitedData"
              />
              <v-card color="black" variant="outlined" class="mb-5">
                <v-locale-provider locale="en">
                  <v-otp-input
                    :height="'85px'"
                    v-model="enterdOtp"
                    length="4"
                    @keyup.enter="submitedData"
                  ></v-otp-input>
                </v-locale-provider>
              </v-card>
            </div>
          </v-slide-y-reverse-transition>
        </div>
        <Alert
          v-if="invalidValue"
          mode="warning"
          class="mb-2"
          :alertContent="$t('missingPhoneOrMail.LoginPage')"
        ></Alert>
        <Alert
          v-else-if="authFaild"
          mode="warning"
          class="mb-3"
          :alertContent="errorMessage"
        ></Alert>
        <BaseButton
          @click="submitedData"
          :loading="loading"
          paddingTop="20px"
          paddingBottom="20px"
          paddingLeft="25px"
          paddingRight="25px"
          icon="mdi-arrow-left-circle"
        >
          <v-slide-x-transition
            v-if="!isOtpFieldOpen"
            :leave-absolute="true"
            :hide-on-leave="true"
          >
            <div>
              <v-icon
                :icon="'mdi-cellphone-arrow-down-variant'"
                :color="'white'"
              />
              {{ $t("LoginPage.loginButton") }}
            </div>
          </v-slide-x-transition>
          <v-slide-x-reverse-transition
            v-else
            :leave-absolute="true"
            :hide-on-leave="true"
          >
            <div class="btn-enter">
              <v-icon :icon="'mdi-arrow-left-circle'" :color="'white'" />
              {{ $t("LoginPage.eneter") }}
            </div>
          </v-slide-x-reverse-transition>
        </BaseButton>
      </v-form>
    </div>
    <ReceivesMailingModel
      @closeModel="closeMailingModel"
      :isLoading="isLoadingSetUserMailing"
      v-if="isReceivesMailingModalOpen"
    />
    <!-- <ReceivesMailingModel :showDialog="true"/> -->
  </div>
</template>

<script>
import AuthService from "@/services/AuthService";
import Alert from "../helpers/Alert.vue";
import { mapActions, mapGetters } from "vuex";
import BaseButton from "../UI/BaseButton.vue";
import ReceivesMailingModel from "../UI/modals/Login/ReceivesMailingModel.vue";

export default {
  components: {
    Alert,
    BaseButton,
    ReceivesMailingModel,
  },
  data() {
    return {
      userInput: "",
      enterdOtp: "",
      isReceivesMailingModalOpen: false,
      isLoadingSetUserMailing: false,
      showIconPassShow: true,
      loading: false,
      authFaild: false,
      isPassShow: false,
      // loadingData: false,
      invalidValue: false,
      errorMessage: "",
      resetPassModalIsVisible: false,
      form: false,
      isOtpFieldOpen: false,
      resendTimeout: 60 * 5,
      otpAbortController: null,
    };
  },
  beforeUnmount() {
    this.otpAbortController?.abort();
  },
  watch: {
    userInput(val) {
      if (val === "") {
        this.invalidValue = false;
        this.authFaild = false;
      }
    },
    enterdOtp(val) {
      if (val === "") {
        this.invalidValue = false;
        this.authFaild = false;
      }
    },
  },
  methods: {
    ...mapActions({
      setLoginModel: "AuthModule/setLoginModel",
      setIsUserGuest: "AuthModule/setIsUserGuest",
      setUserMailing: "AuthModule/setUserMailing",
    }),
    clearLoginForm() {
      this.otpAbortController?.abort();
      this.isReceivesMailingModalOpen = false;
      this.isOtpFieldOpen = false;
      this.invalidValue = false;
      this.authFaild = false;
      this.userInput = "";
      this.enterdOtp = "";
    },
    // WebOTP API (Chrome/Android) reads the SMS's "@domain #code" line and fills+submits without the user typing.
    async startWebOtpAutofill() {
      if (!("OTPCredential" in window)) return;
      this.otpAbortController = new AbortController();
      try {
        const otp = await navigator.credentials.get({
          otp: { transport: ["sms"] },
          signal: this.otpAbortController.signal,
        });
        if (otp?.code) {
          this.enterdOtp = otp.code;
          this.submitedData();
        }
      } catch (error) {
        console.log("WebOTP autofill unavailable/cancelled:", error);
      }
    },
    // iOS (Safari/Chrome, both WebKit) fills the WHOLE code into whichever input is focused. Vuetify's
    // v-otp-input boxes are maxlength=1 each, so the real boxes truncate it to one digit. This transparent
    // proxy sits on top of the visible boxes (so real taps land on it, not just a programmatic .focus() —
    // iOS ignores focus() calls outside a synchronous user gesture) and has no such maxlength limit, so
    // both manual typing and the iOS autofill suggestion land here correctly and mirror into enterdOtp.
    focusOtpAutofillProxy() {
      this.$nextTick(() => this.$refs.otpAutofillProxy?.focus());
    },
    onOtpAutofillProxyInput(e) {
      // Do NOT write back to e.target.value here - mutating a one-time-code field's own
      // value from inside its input handler silently breaks further typing on iOS Safari.
      const code = e.target.value.replace(/\D/g, "").slice(0, 4);
      this.enterdOtp = code;
      if (code.length === 4) {
        this.submitedData();
      }
    },
    async closeMailingModel(isApprovedMaliling) {
      try {
        if (isApprovedMaliling) {
          this.isLoadingSetUserMailing = true;
          await this.setUserMailing({
            standartMailing: true,
          });
          setTimeout(() => {
            this.clearLoginForm();
            this.setIsUserGuest(false);
            this.setLoginModel(false);
            // this.$router.push("/account/orders");
          }, 1000);
        } else {
          await this.$store.dispatch("AuthModule/logout");
          this.clearLoginForm();
        }
      } catch (error) {
        console.log(error);
        this.isLoadingSetUserMailing = false;
      }
    },
    startResendTimer() {
      const timer = setInterval(() => {
        this.resendTimeout--;
        if (this.resendTimeout === 0) {
          clearInterval(timer);
          this.resendTimeout = 60 * 5;
          this.isOtpFieldOpen = false;
          this.invalidValue = false;
          this.authFaild = false;
        }
      }, 1000);
    },
    required(v) {
      return !!v || this.$t("LoginPage.mandatoryFieldError");
    },
    counter() {
      this.$store.state.counter++;
    },
    async submitedData() {
      if (this.loading) return;
      this.invalidValue = false;
      this.authFaild = false;
      if (!this.form) return;

      if (this.userInput && this.enterdOtp === "" && !this.isOtpFieldOpen) {
        this.loading = true;
        try {
          const response = await AuthService.login({
            userInput: this.userInput,
          });

          if (response.status === 200) {
            this.isOtpFieldOpen = true;
            this.startResendTimer();
            this.startWebOtpAutofill();
            this.focusOtpAutofillProxy();
          } else throw new Error();
          return;
        } catch (error) {
          console.log(error);
          this.errorMessage =
            error?.response?.data?.error ??
            this.$t("LoginPage.errorLoginServerSide");
          this.authFaild = true;
          return;
        } finally {
          this.loading = false;
        }
      }

      if (this.isOtpFieldOpen && this.enterdOtp) {
        this.loading = true;
        try {
          const response = await AuthService.verifyOtp({
            userInput: this.userInput,
            otp: this.enterdOtp,
          });

          localStorage.setItem("user", JSON.stringify(response.data.user));
          localStorage.setItem("token", response.data.token);

          this.$i18n.locale = response.data.user.language;

          await this.$store.dispatch("AuthModule/login", {
            user: response.data.user,
            token: response.data.token,
          });

          console.log("user date:");
          console.log(response.data.user);
          console.log("");

          await this.$store.dispatch("Orders/getUserCart");

          await this.$store.dispatch("Parts/findParts", {
            ...this.$route.query,
          });

          // remove the isGuest flag from local storage if exists
          await this.setIsUserGuest(false);

          const getBigDataSucceeded = await AuthService.getBigData();
          console.log("get big data Succeeded?");
          console.log(getBigDataSucceeded);

          if (!response.data.user.isReceivesMailing) {
            this.isReceivesMailingModalOpen = true;
            this.loading = false;
            this.authFaild = false;
            return;
          }

          this.loading = false;
          this.authFaild = false;
          this.setLoginModel(false);
          // this.$router.push("/account/orders");
        } catch (error) {
          this.authFaild = true;
          this.errorMessage =
            error?.response?.data?.error ??
            this.$t("LoginPage.errorLoginServerSide");
          this.loading = false;
        }
      } else if (this.isOtpFieldOpen && !this.enterdOtp) {
        this.authFaild = true;
        this.errorMessage = this.$t("LoginPage.emptyOtpInput");
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
    }),
  },
};
</script>

<style lang="scss">
.side-nav-login {
  border-radius: 10px !important;
  border: 1px solid #dcdcdc;
  padding: 50px;
  width: 100%;
  background: white;
  text-align: start;

  .v-otp-input {
    padding-bottom: 0px;
    justify-content: flex-end;
  }
  .v-otp-input__content {
    max-width: 100%;
    padding: 5px 0px;
  }
  .v-field:has(#userEmail) .v-field__outline {
    display: none;
  }
  .v-card {
    border: unset;
  }

  .v-field__outline {
    border-radius: 10px !important;
  }

  .v-field__overlay {
    background: white !important;
  }
  .v-field__input {
    border: 1px solid #ececec !important;
    border-radius: 10px;
    font-weight: 400 !important;
  }
  .v-btn__content {
    width: 310px;
  }

  .v-input__control {
    padding-left: unset;
    .v-field {
      padding-left: unset;
    }
  }
  input {
    height: 100% !important;
    font-weight: 700;
  }
}

@media (max-width: 601px) {
  .side-nav-login {
    padding: 20px;
  }
}

.v-form {
  width: 100%;
}
#userEmail {
  padding-bottom: 5px;
  color: $orderLineColor;
}
</style>
<style scoped lang="scss">
.otp-input-container {
  position: relative;
}
.otp-autofill-proxy {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  opacity: 0;
  border: none;
  outline: none;
  background: transparent;
  color: transparent;
  caret-color: transparent;
  -webkit-text-fill-color: transparent;
  font-size: 16px; // iOS zooms the page on focus if the focused input's font-size is under 16px
  pointer-events: auto;
}
.password-input-container {
  position: relative;

  i {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 22px;
    cursor: pointer;
    color: grey;
  }
}
a {
  color: $secondaryTextColor;
  cursor: pointer;
}
#loginform {
  // padding: 20px 30px;
}
#forgot-password-container {
  margin-top: 20px;
}

h1 {
  font-size: 72px;
  background: $primaryColor;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: $h1TextTitleSize;
  font-weight: 700;
  margin-bottom: 0px;
  margin-top: 0px;
}
.context {
  font-size: $mediumTextSize;
  color: $orderLineColor;
  margin-bottom: 20px;
}
label {
  font-size: $mediumTextSize;
  font-weight: 700;
}

.svg {
  position: absolute;
  bottom: 0px;
  z-index: 0;
}

.btn-enter {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
}

@media only screen and (max-width: 900px) {
  .material-icons {
    right: 320px;
  }
}

@media only screen and (max-width: 400px) {
  .btn-enter {
    justify-content: space-around;
  }
}
</style>
